import script from "./admin-oportunity.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-oportunity.vue?vue&type=script&setup=true&lang=js"

import "./admin-oportunity.vue?vue&type=style&index=0&id=6d77299c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d77299c"]])

export default __exports__